import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core";

function Sports() {
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);
    
    // State lưu trữ dữ liệu banner
    const [notify, setNotify] = useState(() => {
        const saved = localStorage.getItem("notify");
        return saved ? JSON.parse(saved) : [];
    });

    const autoRecoverMoney = (productType) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: productType })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: productType,
                        type: 2,
                        money: Math.floor(currentBalance)
                    });
                }
                return Promise.resolve();
            })
            .then(() => {
                localStorage.removeItem("playing_product");
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => {
                console.log("Lỗi tự động thu hồi tiền phiên cũ:", err);
            });
    };

    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Lấy thông tin user
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));

                const interruptedProduct = localStorage.getItem("playing_product");
                if (interruptedProduct) {
                    autoRecoverMoney(interruptedProduct);
                }
            })
            .catch((err) => {
                localStorage.removeItem("user");
            });

        // Lấy dữ liệu Banner (Notify)
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {})
            .then((res) => {
                if (JSON.stringify(notify) !== JSON.stringify(res.data.data)) {
                    setNotify(res.data.data);
                    localStorage.setItem("notify", JSON.stringify(res.data.data));
                }
            }).catch(() => {});

        return () => {
            axios.interceptors.request.eject(interceptor);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handlePopState = (event) => {
            if (playGame) {
                handleCloseGame();
            }
        };
        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [playGame, product]);

    function isMobileDevice() {
        if (window.innerWidth < 800) {
            return true;
        }
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    function launchGame(params) {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") === "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading === true) return;

        const form = {
            ...params,
            platform: isMobileDevice() === true ? "html5" : "html5-desktop"
        };

        setLoading(true);

        let a;
        switch (params.product_type) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "98": a = "PG"; break;
            case "99": a = "TF"; break;
            case "3": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            case "61": a = "IMES"; break;
            case "132": a = "SV388"; break;
            default: a = ""; break;
        }
        setSanh(a);
        setProduct(params.product_type);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form)
            .then((res) => {
                if (res.data.data.status == 0) {
                    const gameUrl = res.data.data.game_url;

                    if (profile && profile.money > 0) {
                        const amountToTransfer = Math.floor(profile.money);
                        const autoTransferData = {
                            product_type: params.product_type,
                            type: 1,
                            money: amountToTransfer
                        };

                        axios
                            .post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoTransferData)
                            .then(() => {
                                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((userRes) => {
                                    setProfile(userRes.data.data);
                                    localStorage.setItem("profile", JSON.stringify(userRes.data.data));
                                    localStorage.setItem("playing_product", params.product_type);
                                    window.history.pushState({ inGame: true }, "");

                                    setPlayGame(gameUrl);
                                    setLoading(false);
                                });
                            })
                            .catch((err) => {
                                localStorage.setItem("playing_product", params.product_type);
                                window.history.pushState({ inGame: true }, "");
                                setPlayGame(gameUrl);
                                setLoading(false);
                            });
                    } else {
                        localStorage.setItem("playing_product", params.product_type);
                        window.history.pushState({ inGame: true }, "");
                        setPlayGame(gameUrl);
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                }
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            });
    }

    const handleCloseGame = () => {
        setLoading(true);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    const autoWithdrawData = {
                        product_type: product,
                        type: 2,
                        money: Math.floor(currentBalance)
                    };
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoWithdrawData);
                }
                return Promise.resolve();
            })
            .then(() => {
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
                localStorage.removeItem("playing_product");
                setPlayGame(null);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setPlayGame(null);
                swal("Thông báo", "Hệ thống đang xử lý lệnh kết toán muộn. Vui lòng kiểm tra lại số dư ví tổng sau ít phút.", "warning");
            });
    };

    // Cấu hình cho Swiper banner
    const swiperParams = {
        modules: [Autoplay, Pagination],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: { clickable: true },
    };

    return (
        <>
            <Header profile={profile} />
            
            <style>{`
                /* Đổi màu nền sang Dark Theme */
                .sports-page-wrapper {
                    background-color: #1b1e36;
                    min-height: 100vh;
                    font-family: 'Montserrat', sans-serif;
                    padding-bottom: 50px;
                }

                /* Banner Thể Thao Full Width */
                .main-banner-wrap {
                    width: 100%;
                    overflow: hidden;
                    margin-bottom: 20px;
                }
                
                /* Tùy chỉnh màu nút chấm tròn pagination của Swiper */
                .swiper-pagination-bullet { background: #fff; opacity: 0.5; }
                .swiper-pagination-bullet-active { background: #00e5ff; opacity: 1; }

                /* Container Lưới Ảnh */
                .sports-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 20px 15px;
                }
                
                /* Layout dạng lưới 2 cột */
                .sports-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 25px; 
                }
                
                /* Các nút sảnh game - Đã xóa box-shadow */
                .sport-image-btn {
                    width: 100%;
                    height: auto;
                    cursor: pointer;
                    display: block;
                    transition: transform 0.3s ease, filter 0.3s ease;
                    border-radius: 8px; /* Bo góc nhẹ cho sắc nét */
                }
                
                /* Hiệu ứng hover nổi bật - Đã xóa box-shadow */
                .sport-image-btn:hover {
                    transform: translateY(-5px);
                    filter: brightness(1.1);
                }
                
                /* Responsive cho điện thoại */
                @media (max-width: 768px) {
                    .sports-grid {
                        grid-template-columns: 1fr; /* Xuống 1 cột trên Mobile */
                        gap: 15px;
                    }
                    .main-banner-wrap {
                        margin-bottom: 10px;
                    }
                }
            `}</style>

            {isLoading === true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}
            
            <div className="sports-page-wrapper">
                
                {/* BANNER ĐỘNG TỪ API */}
            {notify && notify.length > 0 && (
                <div className="main-banner-wrap">
                    <Swiper {...swiperParams}>
                        {notify.map((item, index) => {
                            // CHỈ HIỂN THỊ CÁC THÔNG BÁO CÓ VỊ TRÍ LÀ 'home' (BANNER TRANG CHỦ)
                            if (item.isShow === true && item.displayLocation === "home") {
                                return (
                                    <SwiperSlide key={index}>
                                        <img 
                                            alt={item.title ? item.title.replace(/[{}]+/g, "") : "Banner"} 
                                            src={item.image} 
                                            style={{ width: "100%", maxHeight: "500px", objectFit: "cover", display: "block" }} 
                                        />
                                    </SwiperSlide>
                                )
                            }
                            return null;
                        })}
                    </Swiper>
                </div>
            )}
                <div className="sports-container">
                    <div className="sports-grid">
                        {/* 1. SABA SPORTS */}
                        <img 
                            className="sport-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__sports-sb_1780343093384.avif" 
                            alt="SABA SPORTS" 
                            onClick={() => launchGame({ product_type: "174", game_code: "SB0001" })} 
                        />

                        {/* 2. CMD368 SPORTS */}
                        <img 
                            className="sport-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__sports-cmd_1780343111635.avif" 
                            alt="CMD368 SPORTS" 
                            onClick={() => launchGame({ product_type: "104", game_code: "CMD001" })} 
                        />

                        {/* 3. SBO SPORTS */}
                        <img 
                            className="sport-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__sports-sbo_1780343131345.avif" 
                            alt="SBO SPORTS" 
                            onClick={() => launchGame({ product_type: "54", game_code: "SBO041" })} 
                        />

                        {/* 4. UG SPORTS */}
                        <img 
                            className="sport-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__sports-ug2_1780343148519.avif" 
                            alt="UG SPORTS" 
                            onClick={() => launchGame({ product_type: "151", game_code: "UG2001" })} 
                        />
                         <img 
                            className="sport-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__sports-bti_1780343187867.avif" 
                            alt="BTI SPORTS" 
                            onClick={() => launchGame({ product_type: "142", game_code: "FB0001" })} 
                        />
                    </div>
                </div>
            </div>

            {/* IFRAME HIỂN THỊ GAME */}
            {playGame ? (
                <div 
                    className="iframe-game-backdrop" 
                    style={{ 
                        position: "fixed", 
                        top: 0, 
                        left: 0, 
                        width: "100vw", 
                        height: "100vh", 
                        backgroundColor: "#000", 
                        zIndex: 99999,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <div style={{
                        width: "100%",
                        height: "50px",
                        backgroundColor: "#162a35", 
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 15px",
                        boxSizing: "border-box"
                    }}>
                        <div style={{ 
                            color: "#ffcc00", 
                            fontWeight: "bold", 
                            fontSize: "18px",
                            fontFamily: "sans-serif"
                        }}>
                            {sanh}
                        </div>
                        <button 
                            onClick={handleCloseGame} 
                            style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "center",
                                gap: "4px",
                                backgroundColor: "#ff5050", 
                                color: "#fff", 
                                border: "none",
                                borderRadius: "20px", 
                                padding: "6px 16px",
                                fontSize: "14px",
                                fontWeight: "600",
                                cursor: "pointer"
                            }}
                        >
                            <CloseIcon sx={{ fontSize: "18px" }} /> Thoát
                        </button>
                    </div>
                    
                    <iframe 
                        src={playGame} 
                        title={`Sảnh Thể Thao ${sanh}`}
                        style={{ 
                            width: "100%", 
                            flexGrow: 1, 
                            border: "none" 
                        }} 
                        allowFullScreen
                    ></iframe>
                </div>
            ) : null}
        </>
    );
}

export default Sports;